import React from 'react'
import useWindowSize from '../../hooks/useWindowSize'
import Carousel from '../Carousel'
import carouselConfig from '../Carousel/Carousel.config'
import * as Styled from './Columns.styles'

const Columns = ({
  children,
  cardStyled = false,
  extraTopSpacingForLabel = false,
  layout = 'Default',
  leftAligned = true,
  mobileCarousel = false,
  packageCardLayout = 'Default',
  carousel = 'No',
  boxShadow = null,
  ...props
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 650

  const showMobileCarouselOnly =
    (isMobile && mobileCarousel) || carousel === 'Yes, mobile only'

  const isCarousel =
    (isMobile && mobileCarousel) || (carousel && carousel !== 'No')

  if (showMobileCarouselOnly) {
    if (isMobile) {
      return (
        <Styled.Carousel
          style={{ paddingTop: extraTopSpacingForLabel ? '32px' : '0' }}
          cardStyled={cardStyled}
          leftAligned={leftAligned}
          mobileCarousel={mobileCarousel}
          layout={layout}
          packageCardLayout={packageCardLayout}
          extraTopSpacingForLabel={extraTopSpacingForLabel}
          isMobile={isMobile}
        >
          <Carousel
            inColumns
            columnsLayout={layout}
            options={carouselConfig}
            columnsLeftAligned={leftAligned}
            slideCount={children?.length}
            slides={children}
            carouselLayout={carousel}
          >
            {children}
          </Carousel>
        </Styled.Carousel>
      )
    }

    return (
      <Styled.Columns
        className={`leshen-columns leshen-columns-${
          cardStyled ? 'card' : 'default'
        }`}
        extraTopSpacingForLabel={extraTopSpacingForLabel}
        numberOfChildren={children.length}
        cardStyled={cardStyled}
        leftAligned={leftAligned}
        layout={layout}
        packageCardLayout={packageCardLayout}
        {...props}
      >
        {children}
      </Styled.Columns>
    )
  }

  if (isCarousel) {
    return (
      <Styled.Carousel
        style={{ paddingTop: extraTopSpacingForLabel ? '32px' : '0' }}
        cardStyled={cardStyled}
        leftAligned={leftAligned}
        mobileCarousel={mobileCarousel}
        layout={layout}
        packageCardLayout={packageCardLayout}
        extraTopSpacingForLabel={extraTopSpacingForLabel}
        isMobile={isMobile}
      >
        <Carousel
          inColumns
          columnsLayout={layout}
          options={carouselConfig}
          columnsLeftAligned={leftAligned}
          slideCount={children?.length}
          slides={children}
          carouselLayout={carousel}
          boxShadow={boxShadow}
        >
          {children}
        </Carousel>
      </Styled.Carousel>
    )
  }

  return (
    <Styled.Columns
      className={`leshen-columns leshen-columns-${
        cardStyled ? 'card' : 'default'
      }`}
      extraTopSpacingForLabel={extraTopSpacingForLabel}
      numberOfChildren={children.length}
      cardStyled={cardStyled}
      leftAligned={leftAligned}
      layout={layout}
      packageCardLayout={packageCardLayout}
      {...props}
    >
      {children}
    </Styled.Columns>
  )
}

export default Columns
